import React, { Component, useState, useEffect, useRef, useLayoutEffect } from 'react'

import { AnimatePresence, motion, useMotionValue, useTransform, animate, useScroll, useMotionValueEvent, useAnimationControls, motionValue } from "framer-motion"

import { NavLink, Link } from "react-router-dom"

import Modal from 'react-modal';

import IconButton from '../../elements/IconButton'
import Dropdown from '../../elements/ReactSelectDropdown'
import TextInput from '../../elements/TextInput'
import Button from '../../elements/Button'

const Main = (props) => {

    const [data, setData] = useState({
        amount: '',
        reason: '',
        ATTN: '',
        address: {value: '', label: ''},
    })

    const onDataChange = (e, value) => {
        setData(prevData => ({
            ...prevData,
            [value]: e
        }))
    }

    const [shippingTypes, setShippingTypes] = useState([
        { value: 1, label: 'Dealer Address' },
        { value: 2, label: 'Spiffee Address' },
        { value: 3, label: 'Subagent Owner Address' },
    ])

    return (
        <div style={{width: '360px', height: 'auto', display: 'flex', flexDirection: 'column'}}>
            <div style={{flexBasis: '10%', display: 'flex', flexDirection: 'row'}}>
                <span style={{fontWeight: '500', fontSize: '20px', flexBasis: '99%'}}>Edit Balance</span>
                <IconButton img={false} colors={props.colors} Style={{borderRadius: '3px', backgroundColor: props.colors.border, width: '24px'}} size="16px">
                    <div onClick={props.setIsOpen} style={{paddingLeft: '3px', paddingRight: '3px'}}><span onClick={props.setIsOpen}>x</span></div>
                </IconButton>
            </div>
            <div style={{flexBasis: '90%', display: 'flex', flexDirection: 'column', marginTop: '0px'}}>
                <div style={{display: 'flex', flexDirection: 'column', flexGrow: 1, marginRight: '10px', marginTop: '20px'}}>
                    <span style={{fontWeight: '500'}}>Adjustment Amount</span>
                    <TextInput colors={props.colors} onChange={(e) => onDataChange(e, 'amount')} Style={{marginTop: '10px'}} data={data.amount} prefix='$'></TextInput>
                </div>
                <div style={{display: 'flex', flexDirection: 'column', flexGrow: 1, marginRight: '10px', marginTop: '20px'}}>
                    <span style={{fontWeight: '500'}}>Reason</span>
                    <TextInput colors={props.colors} onChange={(e) => onDataChange(e, 'reason')} Style={{marginTop: '10px'}} data={data.reason} prefix=''></TextInput>
                </div>
                <div style={{display: 'flex', flexDirection: 'column', flexGrow: 1, marginRight: '10px', marginTop: '20px'}}>
                    <span style={{fontWeight: '500'}}>Shipping Address</span>
                    <div style={{marginTop: '5px'}}><Dropdown colors={props.colors} onChange={(e) => onDataChange(e, 'address')} index={props.index} indexParent={props.indexParent} data={shippingTypes} value={data.address.label}></Dropdown></div>
                </div>
                <div style={{display: 'flex', flexDirection: 'column', flexGrow: 1, marginRight: '10px', marginTop: '20px'}}>
                    <span style={{fontWeight: '500'}}>ATTN</span>
                    <TextInput colors={props.colors} onChange={(e) => onDataChange(e, 'ATTN')} Style={{marginTop: '10px'}} data={data.ATTN} prefix=''></TextInput>
                </div>
                <Button onClick={() => props.adjustDealership(data)} colors={props.colors} active={true} Style={{marginLeft: 'auto', width: '100%', marginTop: '25px'}}>Submit</Button>
            </div>
        </div>
    )
}

export default Main
